<mat-card class="mat-elevation-z1">
    <div class="action-container">
        <h2 class="table-title">Legislative Items</h2>

        <div class="search-container" color="primary">
            <app-search-bar #search (searchEvent)="applyFilter($event);" (clearSearchEvent)="clearFilter();"></app-search-bar>
        </div>
    </div>

    <table mat-table [dataSource]="dataSource" [trackBy]="trackBy">
        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef style="width: 125px"></th>
            <td mat-cell *matCellDef="let item">
                <button mat-flat-button color="primary" (click)="editItem(item)">Edit</button>
                <!-- <button mat-flat-button color="accent" (click)="expandedEvent = expandedEvent === event ? null : event">Details</button> -->
                <button mat-flat-button color="warn" (click)="deleteItem(item)">Delete</button>
                <!-- <button mat-icon-button color="primary" [matMenuTriggerFor]="menu">
                    <mat-icon>more_vertical</mat-icon>
                </button>
                <mat-menu #menu="matMenu" style="width: 150px">
                    <button mat-menu-item (click)="editItem(item)"><mat-icon color="primary">edit</mat-icon>Edit</button>
                <button mat-menu-item (click)="viewItem(item)">
                    <mat-icon color="primary">visibility</mat-icon>View Details
                </button>
                <button mat-menu-item (click)="deleteItem(item)"><mat-icon color="warn">delete</mat-icon>Delete</button>
                </mat-menu> -->
            </td>
        </ng-container>

        <!-- Position Column -->
        <!-- <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef>No.</th>
            <td mat-cell *matCellDef="let item; let i = index">{{ i+1 }}</td>
        </ng-container> -->

        <!-- ID Column -->
        <!-- <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let item">{{ item.id }}</td>
        </ng-container> -->

        <!-- Title Column -->
        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>Legislative Item</th>
            <td mat-cell *matCellDef="let item">{{ item.title }}</td>
        </ng-container>

        <!-- About Column -->
        <!-- <ng-container matColumnDef="about">
            <th mat-header-cell *matHeaderCellDef width="auto">About</th>
            <td mat-cell *matCellDef="let item" class="overflowContainer">
                <div class="ellipse">
                    <span>{{item.about}}</span>
                </div>
            </td>
        </ng-container> -->

        <!-- Active Column -->
        <ng-container matColumnDef="active">
            <th mat-header-cell *matHeaderCellDef style="text-align: center; width: 125px;">Status</th>
            <td mat-cell *matCellDef="let item">
                <!-- <span class="status" [ngClass]="{'active': item.active}">{{ item.active ? 'Active' : 'Hidden' }}</span> -->
                <mat-chip-list aria-label="Fish selection" selectable="false" class="statusChips">
                    <mat-chip chipListSelectable="false" class="status" [class.active]="item?.active">
                        {{ item?.active ? 'Active' : 'Hidden' }}</mat-chip
                    >
                </mat-chip-list>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay; let even = even" [class.evenRow]="even"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="columnsToDisplay.length">
                No items matching the filter
                <span *ngIf="search.value"> "{{ search.value }}"</span>
            </td>
        </tr>
    </table>

    <div *ngIf="isLoading" style="padding: 1em">Loading data...</div>
</mat-card>